// Gemeinsame Datums-Helfer für die Förderliste (De-minimis).
// `datum` wird als String gespeichert — mal ISO (JJJJ-MM-TT, aus <input type="date">),
// mal deutsch (TT.MM.JJJJ, z. B. aus synchronisierten Vorgängen). Beide Formate parsen,
// damit Sortierung chronologisch stimmt (nicht nach String).

/** Parst TT.MM.JJJJ oder ISO JJJJ-MM-TT zu einem Date; sonst null. */
export function parseFoerderDatum(datum?: string | null): Date | null {
  if (!datum) return null;
  const s = String(datum).trim();
  const de = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (de) return new Date(Number(de[3]), Number(de[2]) - 1, Number(de[1]));
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  return null;
}

/** Formatiert ein Datum als TT.MM.JJJJ (BAFA-Format). Unparsebar → Original zurück. */
export function formatFoerderDatum(datum?: string | null): string {
  if (!datum) return '';
  const d = parseFoerderDatum(datum);
  if (!d) return String(datum);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
}

/**
 * Sortiert Förderungen aufsteigend nach Datum (ältestes zuerst).
 * Einträge ohne parsebares Datum wandern ans Ende (z. B. frisch hinzugefügte,
 * noch leere Zeilen) — passt zu „unten das neueste". Stabil, mutiert nicht.
 */
export function sortFoerderungenByDatum<T extends { datum?: string | null }>(list: T[]): T[] {
  return list
    .map((item, index) => ({ item, index, d: parseFoerderDatum(item.datum) }))
    .sort((a, b) => {
      if (a.d && b.d) return a.d.getTime() - b.d.getTime() || a.index - b.index;
      if (a.d) return -1;
      if (b.d) return 1;
      return a.index - b.index;
    })
    .map((x) => x.item);
}
